module.exports = __webpack_public_path__ + "img/blue_058.c2f803c9.png";